import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

export const getCategories = async () => {
  const { data } = await axios(`${API_URL}/category`);
  return data;
};
